<template>
  <SvoiButtonLink
    :link="link"
    :component-type="resolvedComponentType"
    :target="target"
    :name="name"
    :theme="theme"
    :theme-type="themeType"
    :size="size"
    :disabled="disabled"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :border-radius="borderRadius"
    :tabindex="tabindex"
    :qa-locator="qaLocator"
  />
</template>

<script lang="ts" setup>
/**
 * Кнопка-ссылка через границу приложений: своя зона - NuxtLink,
 * чужая - <a href> с полной перезагрузкой.
 * @see ~/composables/use-app-zones.ts - реестр зон и isOwnRoute
 */
import { SvoiButtonLink } from '@svoi-ui/components/button'
import { LinkTypesEnum } from '@svoi-ui/interfaces/link-type'
import { useAppZones } from '~/composables/use-app-zones'

const props = defineProps<{
  link: string
  componentType?: string
  target?: string
  name?: string
  theme?: string
  themeType?: string
  size?: string
  disabled?: boolean
  iconLeft?: string
  iconRight?: string
  borderRadius?: string
  tabindex?: number
  qaLocator?: string
}>()

const { isOwnRoute } = useAppZones()

const resolvedComponentType = computed(() => {
  if (props.componentType) return props.componentType

  return isOwnRoute(props.link) ? LinkTypesEnum.nuxtLink : LinkTypesEnum.a
})
</script>
